import React from 'react';
import type { FieldFormProps } from '@helpcenter/field-types';
import { FieldSingleSelect } from '@helpcenter/form-select';
import TagIcon from '@atlaskit/icon/core/tag';
import { Box } from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { ExperienceSuccess } from '@atlassian/ufo/experience-success';
import { entitlementPickerLoadExperience } from '../experiences';
import type { Option } from '../types';

export interface Props extends Omit<FieldFormProps<string>, 'onChange'> {
	onChange: (value: Option | null, notFromUserInteraction?: boolean) => void;
	isLoading: boolean;
	selectedEntitlement: Option | null;
	entitlements: Option[];
}

const renderOption = (option: { label: string; value: string }) => (
	<Box xcss={optionStyles}>
		<Box xcss={iconContainerStyles}>
			<TagIcon label="" />
		</Box>

		{option.label}
	</Box>
);

export const EntitlementPickerDumb = (props: Props) => {
	const { isLoading, entitlements, selectedEntitlement, ...fieldProps } = props;

	return (
		<>
			{!isLoading && <ExperienceSuccess experience={entitlementPickerLoadExperience} />}
			<FieldSingleSelect
				{...fieldProps}
				actionSubjectId="entitlementPicker"
				value={selectedEntitlement}
				options={entitlements}
				formatOptionLabel={renderOption}
				isDisabled={isLoading || props.disabled}
				isLoading={isLoading}
				isClearable
			/>
		</>
	);
};

const optionStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	gap: 'space.100',
});

const iconContainerStyles = xcss({
	backgroundColor: 'color.background.neutral',
	borderRadius: 'radius.xsmall',
	padding: 'space.025',
});
